import { useSearchParams } from 'react-router-dom';
import EntityDirectoryCards from '../components/EntityDirectoryCards';
import ActiveArchivedToggle from '../components/ActiveArchivedToggle';
import PageShell from '../../../components/layout/PageShell';
import PageHeader from '../components/PageHeader';

// ✅ Custom breadcrumbs example:
// const crumbs = [
//   { label: 'Home', to: '/' },
//   { label: 'Community', to: `/community/${communityId}` },
//   { label: 'Match Manager', to: `/community/${communityId}/match-manager/${managerId}` },
//   { label: 'Manual Match Format' },
// ];
// <PageShell breadcrumbs={crumbs}>...</PageShell>
// <PageShell breadcrumbOverrides={{ tournamentId: tournament?.name || 'Tournament' }}>
const SaClubsPage = () => {
  const [searchParams] = useSearchParams();
  const view = searchParams.get('view') === 'archived' ? 'archived' : 'active';

  return (
    <PageShell containerClassName="p-0">
    <PageHeader title="Clubs" description="Manage active and archived cricket clubs." />
    <section className="card border-0 shadow-sm">
      <div className="card-body d-grid gap-3">
        <ActiveArchivedToggle />
        <EntityDirectoryCards entityType="club" archived={view === 'archived'} />
      </div>
    </section>
  
    </PageShell>
  );
};

export default SaClubsPage;
